import { useId, useState, type ReactNode } from "react";
import { useParams } from "react-router";
import {
  OrderDrillOverlay,
  type OrderDrillTarget,
} from "@acto/taskpane/field-sales-2/components/patterns/order-drilldown";
import { ShellOverlay } from "@acto/taskpane/field-sales-2/shell";

export type OpenOrderDrill = OrderDrillTarget["root"];

interface OrderDrill {
  open: (drill: OpenOrderDrill) => void;
  overlay: ReactNode;
}

export function useOrderDrill(): OrderDrill {
  const { id: clientId } = useParams<{ id: string }>();
  const overlayId = `orderDrill${useId()}`;
  const [openDrill, setOpenDrill] = useState<OpenOrderDrill | null>(null);
  const closeDrill = () => setOpenDrill(null);

  const overlay =
    openDrill && clientId ? (
      <ShellOverlay id={overlayId} label={openDrill.name} onDismiss={closeDrill}>
        <OrderDrillOverlay target={{ clientId, root: openDrill }} onClose={closeDrill} />
      </ShellOverlay>
    ) : null;

  return { open: setOpenDrill, overlay };
}
